/* eslint-disable global-require, max-len */
import loadable from '@loadable/component';

export const HomePage = loadable(
	() => import(/* webpackChunkName: "HomePage" */ './HomePage/HomePage')
);
export const FacilityPage = loadable(
	() => import(/* webpackChunkName: "FacilityPage" */ './FacilityPage/FacilityPage')
);
export const SearchPage = loadable(
	() => import(/* webpackChunkName: "SearchPage" */ './SearchPage/SearchPage')
);

export const SearchPageWrapper = loadable(
	() => import(
		/* webpackChunkName: "SearchPage" */ './SearchPageVariation/SearchPageWrapper'
	)
);
export const SearchPageVariation = loadable(
	() => import(
		/* webpackChunkName: "SearchPageVariation" */ './SearchPageVariation/SearchPageVariation'
	)
);
export const PSPPage = loadable(
	() => import(/* webpackChunkName: "PSPPage" */ './PSPPage/PSPPage')
);
export const BookingConfirmation = loadable(
	() => import(
		/* webpackChunkName: "BookingConfirmation" */ './BookingConfirmation/BookingConfirmation'
	)
);
export const MovingTruckCLPPage = loadable(
	() => import(
		/* webpackChunkName: "MovingTruckCLPPage" */ './MovingTruckCLPPage/MovingTruckCLPPage'
	)
);
export const UnitPage = loadable(
	() => import(/* webpackChunkName: "UnitPage" */ './UnitPage/UnitPage')
);
export const LegalConsumerPage = loadable(
	() => import(
		/* webpackChunkName: "LegalConsumerPage" */ './LegalPages/LegalConsumerPage'
	)
);
export const LegalGiftCardTermsPage = loadable(
	() => import(
		/* webpackChunkName: "LegalGiftCardTermsPage" */ './LegalPages/LegalGiftCardTermsPage'
	)
);
export const LegalConsumerPrivacyPage = loadable(
	() => import(
		/* webpackChunkName: "LegalConsumerPrivacyPage" */ './LegalPages/LegalConsumerPrivacyPage'
	)
);
export const LegalClientLTVPage = loadable(
	() => import(
		/* webpackChunkName: "LegalClientLTVPage" */ './LegalPages/LegalClientLTVPage'
	)
);
export const LegalConsumerPaymentPage = loadable(
	() => import(
		/* webpackChunkName: "LegalConsumerPaymentPage" */ './LegalPages/LegalConsumerPaymentPage'
	)
);
export const LegalReviewsPage = loadable(
	() => import(
		/* webpackChunkName: "LegalReviewsPage" */ './LegalPages/LegalReviewsPage'
	)
);
export const FourOhFourPage = loadable(
	() => import(
		/* webpackChunkName: "FourOhFourPage" */ './FourOhFourPage/FourOhFourPage'
	)
);
export const NewFourOhFourPage = loadable(
	() => import(
		/* webpackChunkName: "NewFourOhFourPage" */ './NewFourOhFourPage/NewFourOhFourPage'
	)
);
export const UnsubscribePage = loadable(
	() => import(
		/* webpackChunkName: "UnsubscribePage" */ './UnsubscribePage/UnsubscribePage'
	)
);
export const StateLandingPage = loadable(
	() => import(
		/* webpackChunkName: "StateLandingPage" */ './StateLandingPage/StateLandingPage'
	)
);
export const MovingTruckPage = loadable(
	() => import(
		/* webpackChunkName: "MovingTruckPage" */ './MovingTruckPage/MovingTruckPage'
	)
);
export const MovingSuppliesPage = loadable(
	() => import(
		/* webpackChunkName: "MovingSuppliesPage" */ './MovingSuppliesPage/MovingSuppliesPage'
	)
);
export const PortableStoragePage = loadable(
	() => import(
		/* webpackChunkName: "PortableStoragePage" */ './PortableStoragePage/PortableStoragePage'
	)
);
export const ReviewPage = loadable(
	() => import(/* webpackChunkName: "ReviewPage" */ './ReviewPage/ReviewPage')
);
export const RebateClaimPage = loadable(
	() => import(
		/* webpackChunkName: "RebateClaimPage" */ './RebateClaimPage/RebateClaimPage'
	)
);
export const RebateStatusPage = loadable(
	() => import(
		/* webpackChunkName: "RebateStatusPage" */ './RebateStatusPage/RebateStatusPage'
	)
);
export const MoveInConfirmStatusPage = loadable(
	() => import(
		/* webpackChunkName: "MoveInConfirmStatusPage" */ './MoveInConfirmStatusPage/MoveInConfirmStatusPage'
	)
);
export const MoveInIncentivePage = loadable(
	() => import(
		/* webpackChunkName: "MoveInIncentivePage" */ './MoveInIncentivePage/MoveInIncentivePage'
	)
);
export const VehicleLengthPage = loadable(
	() => import(
		/* webpackChunkName: "VehicleLengthPage" */ './VehicleLengthPage/VehicleLengthPage'
	)
);
export const SizeGuidePage = loadable(
	() => import(
		/* webpackChunkName: "SizeGuidePage" */ './SizeGuidePage/SizeGuidePage'
	)
);
export const PaidTemplatePage = loadable(
	() => import(
		/* webpackChunkName: "PaidTemplatePage" */ './PaidTemplatePage/PaidTemplatePage'
	)
);
export const EmailAuthPage = loadable(
	() => import(
		/* webpackChunkName: "EmailAuthPage" */ './EmailAuthPage/EmailAuthPage'
	)
);
export const OMIPage = loadable(
	() => import(/* webpackChunkName: "OMIPage" */ './OMIPage/OMIPage')
);
export const FacilityPageV2 = loadable(
	() => import(
		/* webpackChunkName: "FacilityPage" */ './FacilityPageV2/FacilityPageV2'
	)
);
export const StyleGuidePage = loadable(
	() => import(
		/* webpackChunkName: "StyleGuidePage" */ './StyleGuidePage/StyleGuidePage'
	)
);
export const UnitPageV2 = loadable(
	() => import(
		/* webpackChunkName: "UnitReservationPage" */ './UnitPageV2/UnitPage'
	)
);
